import { createBrowserRouter, redirect } from "react-router-dom";
import BuildMyKubota from '../container/BuildMyKubota';
import ProductSelector from '../selector/ProductSelector';
import ProductDetails from '../configurator/ProductDetails';
import bmkservice from '../service/bmk-service';
import { graphqlRequest } from '../service/graphql-client';
import { GQ_GET_BUILD } from '../service/graphql-mutations';

async function sendError(message, returnToHome = false) {
    fetch(bmkservice.errorLog, {
        method: 'post',
        body: message
    });
    if (returnToHome) {
        return redirect("/");
    }
    return null;
}

async function loadProducts(id) {
    if (id === "") {
        return redirect("/");
    }
    const response = await fetch(bmkservice.getProducts + id);
    try {
        const json = await response.json();
        if (!json.ProductGroups) {
            return sendError('Invalid data from ' + bmkservice.getProducts + id, true);
        }
        return json;
    }
    catch (e) {
        return sendError('Unable to parse reponse from ' + bmkservice.getProducts + id, id !== 0);
    }
};

async function loadConfig() {
    const configResponse = await fetch(bmkservice.config);
    const configJson = await configResponse.json();

    const bannerResponse = await fetch(bmkservice.banners);
    const bannerJson = await bannerResponse.json();

    configJson.banners = bannerJson;
    return configJson;
};

async function loadProductDetails(id, request) {
    const productResponse = await fetch(bmkservice.getProductDetails + id);
    const productJson = await productResponse.json();

    if (!productJson.Tractor) {
        return sendError('Invalid data from ' + bmkservice.getProductDetails + id, true);
    }

    if (!productJson.Tractor.MSRPWithoutTires) {
        sendError('No pricing from ' + bmkservice.getProductDetails + id);
    }

    if (!productJson.Tractor.ImagePath) {
        sendError('No images from ' + bmkservice.getProductDetails + id);
    }

    productJson.studios = {};
    productJson.imageMappingData = [];

    const equipResponse = await fetch(bmkservice.getProductEquipment + id);
    const equipment = await equipResponse.json();
    productJson.equipmentHtml = equipment.replaceAll('/images/', '/assets/kubotatractor/');

    if (productJson.Tractor.ConfigSirvLink) {
        const configSirvPath = productJson.Tractor.ConfigSirvLink.replace('keyshot-configurator.html', '');

        const configResponse = await fetch(configSirvPath + 'keyshot-configurator-modeldata.js');
        const configJs = await configResponse.text();

        if (configJs.indexOf('model') === 0) {
            eval('window.' + configJs);
            window.model.studios.forEach((studio) => {
                productJson.studios[studio.name] = { icon: configSirvPath + 'icons/' + encodeURIComponent(studio.icon), id: studio.id };
            });
        }

        const imgResponse = await fetch(configSirvPath + 'keyshot-configurator-imagemapping.js');
        const imgJs = await imgResponse.text();

        if (imgJs.indexOf('imagemappingdata') === 0) {
            eval('window.' + imgJs);
            productJson.imageMappingData = window.imagemappingdata;
        }
    }

    productJson.configuration = new window.ProductConfiguration(productJson.Tractor, productJson.RuleList);
    if (productJson.Tractor.DefaultTires) {
        productJson.configuration.addItem(productJson.Tractor.DefaultTires);
    }

    const buildId = new URL(request.url).searchParams.get('build-id');
    if (buildId) {
        // Get access token from localStorage or Redux store
        const accessToken = localStorage.getItem('access_token') || 
                           (window.__REDUX_STORE__ && window.__REDUX_STORE__.getState().auth.accessToken);
        
        try {
            // Use GraphQL query to get single build
            const data = await graphqlRequest(GQ_GET_BUILD, { id: buildId }, accessToken);
            
            if (data.build && data.build.configuredItems) {
                productJson.configuration.ConfiguredItem.ChildItems = window._.cloneDeep(JSON.parse(data.build.configuredItems));
            }
        } catch (error) {
            console.error('Error loading build:', error);
            // Continue without loading build configuration if there's an error
        }
    }
    const configSirvLink = productJson.Tractor.ConfigSirvLink || '';
    productJson.baseUrl = configSirvLink.replace('keyshot-configurator.html', '');

    //productJson.AttachHierarchy.LandPrideGroup = null; // temporarily disable landpride addons

    return productJson;
};

const Router = createBrowserRouter([{
    path: "/",
    element: <BuildMyKubota />,
    id: "root",
    loader: loadConfig,
    children: [
        {
            path: "",
            element: <ProductSelector />,
            loader: () => {
                return loadProducts(0);
            }
        },
        {
            path: ":productSlug",
            element: <ProductSelector />,
            loader: ({ params }) => {
                const id = params.productSlug.substring(0, params.productSlug.indexOf('-'));
                return loadProducts(id);
            }
        },
        {
            path: ":productSlug/:seriesSlug",
            element: <ProductSelector />,
            loader: ({ params }) => {
                const id = params.seriesSlug.substring(0, params.seriesSlug.indexOf('-'));
                return loadProducts(id);
            }
        },
        {
            path: ":productSlug/:seriesSlug/:modelName",
            element: <ProductDetails />,
            id: "productDetails",
            loader: ({ params, request }) => {
                return loadProductDetails(params.modelName, request);
            },
            children: [
                { path: ":pageName" }
            ]
        }
    ]
}], {basename: "/"});

export default Router;